module.exports = ".grid-container {\n  margin: 20px;\n}\n\n#import_import .mat-slide-toggle {\n  margin: 0 1em;\n}\n"